import { PropsWithChildren } from 'react'

// No-op wrapper. The language is now set per-request in the App / Footer
// react-on-rails factory bodies (see App.tsx) so SSR and the client's first
// hydration render are guaranteed to agree. Kept as a passthrough so the
// existing App tree doesn't need to change shape; safe to inline later.
const SetLanguage = ({ children }: PropsWithChildren) => <>{children}</>

export default SetLanguage
